import React from 'react';import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Award, Users, Calendar, Target } from 'lucide-react';

const AmateurPage = () => {
  const fighters = [
    {
      name: 'Bond Junior Ngubula',
      weight: '51 Kg',
      age: 21,
      image: 'https://i.imgur.com/MBCXKIT.png'
    },
    {
      name: 'O‘Dean Lessau',
      weight: '63.5 Kg',
      age: 20,
      image: 'https://i.imgur.com/HJcVoIT.jpeg'
    },
    {
      name: 'Yabo Ngubula',
      weight: '61 Kg',
      age: 17,
      image: 'https://i.imgur.com/zYg7aln.jpeg'
    },
    {
      name: 'Kago Raokgwatile',
      weight: '55 Kg',
      age: 20,
      image: 'https://i.imgur.com/MSuyurt.jpeg'
    }
  ];

  const showUpcomingBouts = false;

  const upcomingBouts = [
    {
      date: 'March 30, 2026',
      event: 'Amateur Showcase Vol. 5',
      bout: 'Thabo Molefe vs. TBD',
      rounds: '3 Rounds'
    },
    {
      date: 'April 15, 2026',
      event: '125 Division Championship',
      bout: 'Kgosi Kgosana vs. Lerato Modise',
      rounds: '4 Rounds'
    },
    {
      date: 'May 5, 2026',
      event: 'Youth Boxing Tournament',
      bout: 'Multiple Bouts',
      rounds: 'Various'
    }
  ];

  const clubHighlightImages = [
    'https://i.imgur.com/PJD1dJE.jpeg',
    'https://i.imgur.com/reHP0KJ.jpeg',
    'https://i.imgur.com/tIzrNdd.jpeg',
    'https://i.imgur.com/d8KAJ18.jpeg',
    'https://i.imgur.com/8xvXXLD.jpeg',
    'https://i.imgur.com/fd4wVLf.jpeg',
    'https://i.imgur.com/0HRNMLk.jpeg',
    'https://i.imgur.com/mLOtYPL.jpeg'
  ];

  return (
    <div className="min-h-screen bg-black">

      <SEO
        title="125 Club | Amateur & Youth Boxing in Gaborone | Bond Boxing"
        description="Discover the 125 Club at Bond Boxing in Gaborone, Botswana. Explore amateur boxing development, youth training opportunities and competitive boxing."
        path="/amateur"
      />

      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://i.imgur.com/qZ9DF9L.jpeg"
            alt="125 Club at Bond Boxing"
            fetchPriority="high"
            decoding="async"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 tracking-wider">
            <span className="text-red-600">125</span> Club
          </h1>
          <p className="text-2xl md:text-3xl font-semibold mb-6 italic">
            <span className="text-white">"From The Streets </span>
            <span className="text-red-500">To The Podium"</span>
          </p>
          <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto">
            Developing the next generation of boxing champions through disciplined training and competitive opportunities.
          </p>
        </div>
      </section>

      {/* About 125 CLUB */}
      <section className="bg-zinc-950 py-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-white text-4xl md:text-5xl font-bold mb-6">
                The heart of 125 Club
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                The 125 Club at Bond Boxing is dedicated to nurturing young boxing talent in the 125-pound weight class. Our program provides comprehensive training, competitive opportunities, and mentorship to help amateur boxers develop their skills and achieve their full potential.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                We focus on technical excellence, ring intelligence, and character development, preparing our fighters not just for competition, but for life beyond the ring.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="flex items-start gap-3">
                  <Users className="text-red-500" size={24} />
                  <div>
                    <div className="text-white font-bold text-2xl">50+</div>
                    <div className="text-gray-400 text-sm">Active Amateurs</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Award className="text-red-500" size={24} />
                  <div>
                    <div className="text-white font-bold text-2xl">25+</div>
                    <div className="text-gray-400 text-sm">Championships Won</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://i.imgur.com/tWuDO80.jpeg"
                alt="125 Club amateur boxing training"
                loading="lazy"
                decoding="async"
                className="w-full h-[500px] object-cover shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Development Program */}
      <section className="bg-black py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              Amateur Development Program
            </h2>
            <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto">
              A comprehensive training pathway designed to transform beginners into competitive amateur boxers
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="bg-zinc-950 border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
              <div className="w-16 h-16 bg-red-600 flex items-center justify-center text-white text-2xl font-bold mb-6">
                01
              </div>
              <h3 className="text-white text-xl font-bold mb-4">Fundamentals</h3>
              <p className="text-gray-400">
                Master basic techniques, footwork, and defensive skills. Build a strong foundation in boxing fundamentals.
              </p>
            </div>

            <div className="bg-zinc-950 border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
              <div className="w-16 h-16 bg-red-600 flex items-center justify-center text-white text-2xl font-bold mb-6">
                02
              </div>
              <h3 className="text-white text-xl font-bold mb-4">Skill Development</h3>
              <p className="text-gray-400">
                Advanced training in combination punching, ring movement, and fight strategy.
              </p>
            </div>

            <div className="bg-zinc-950 border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
              <div className="w-16 h-16 bg-red-600 flex items-center justify-center text-white text-2xl font-bold mb-6">
                03
              </div>
              <h3 className="text-white text-xl font-bold mb-4">Competition Prep</h3>
              <p className="text-gray-400">
                Sparring sessions, match simulation, and mental preparation for amateur bouts.
              </p>
            </div>

            <div className="bg-zinc-950 border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
              <div className="w-16 h-16 bg-red-600 flex items-center justify-center text-white text-2xl font-bold mb-6">
                04
              </div>
              <h3 className="text-white text-xl font-bold mb-4">Competition</h3>
              <p className="text-gray-400">
                Regular amateur bouts, tournament participation, and pathway to professional boxing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {false && (
        <section className="bg-zinc-950 py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
                125 Boxers
              </h2>
              <p className="text-gray-400 text-lg">
                Meet our talented 125 Amateur Division boxers
              </p>
            </div>

            <div className="grid md:grid-cols-4 gap-8">
              {fighters.map((fighter, index) => (
                <div
                  key={index}
                  className="bg-black border border-gray-800 hover:border-red-600 transition-all duration-300 overflow-hidden group"
                >
                  <div className="relative h-80 overflow-hidden">
                    <img
                      src={fighter.image}
                      alt={fighter.name}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-white text-xl font-bold mb-2">
                        {fighter.name}
                      </h3>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-red-500 font-bold">
                          Weight: {fighter.weight}
                        </span>
                        <span className="text-gray-400">
                          Age: {fighter.age}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Upcoming Bouts */}
      {showUpcomingBouts && (
        <section className="bg-black py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
                Upcoming Amateur Bouts
              </h2>
              <p className="text-gray-400 text-lg">
                Watch our fighters compete in upcoming events
              </p>
            </div>

            <div className="max-w-4xl mx-auto space-y-6">
              {upcomingBouts.map((bout, index) => (
                <div
                  key={index}
                  className="bg-zinc-950 border border-gray-800 hover:border-red-600 transition-all duration-300 p-6"
                >
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <Calendar className="text-red-500" size={20} />
                        <span className="text-white font-bold">{bout.date}</span>
                      </div>
                      <h3 className="text-white text-xl font-bold mb-2">
                        {bout.event}
                      </h3>
                      <p className="text-gray-400 mb-1">{bout.bout}</p>
                      <span className="text-red-500 text-sm font-semibold">
                        {bout.rounds}
                      </span>
                    </div>
                    <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-semibold transition-all duration-300">
                      Event Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 125 Club Highlights */}
      <section className="bg-black py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              125 Club Highlights
            </h2>
            <p className="text-gray-400 text-lg">
              Moments from the 125 Club journey
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-4">
            {clubHighlightImages.map((img, index) => (
              <div
                key={index}
                className="relative h-64 overflow-hidden group cursor-pointer"
              >
                <img
                  src={img}
                  alt={`125 Club Highlight ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Youth Boxing Opportunities */}
      <section className="bg-zinc-950 py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
                Youth Boxing Opportunities
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed">
                Bond Boxing is committed to developing young talent through our youth amateur program. Youth boxing training starting from age 10, with a focus on skill development, fitness, and character building.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-black border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
                <Target className="text-red-500 mb-4" size={40} />
                <h3 className="text-white text-2xl font-bold mb-4">
                  Program Benefits
                </h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Professional coaching and mentorship</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Access to competition opportunities</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Character and discipline development</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Pathway to professional boxing</span>
                  </li>
                </ul>
              </div>

              <div className="bg-black border border-gray-800 p-8 hover:border-red-600 transition-all duration-300">
                <Users className="text-red-500 mb-4" size={40} />
                <h3 className="text-white text-2xl font-bold mb-4">
                  Enrollment Info
                </h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Ages 10 and above</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Medical clearance required</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Parental consent for minors</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 mt-1">•</span>
                    <span>Scholarship opportunities available</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center mt-12">
              <button
                onClick={() => {
                  window.location.href = '/#contact';
                }}
                className="bg-red-600 hover:bg-red-700 text-white px-12 py-5 font-semibold text-lg tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-red-600/50"
              >
                Join Amateur Program
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AmateurPage;